import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";

const pathBase = `/users/me/phone-number-change/complete/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const complete = {
  post: apiPathFunc(pathBase),
};
